var map = {
	"./": [
		"1030",
		9
	],
	"./en": [
		"da86",
		3,
		"lang-en"
	],
	"./en.json": [
		"da86",
		3,
		"lang-en"
	],
	"./es": [
		"1052",
		3,
		"lang-es"
	],
	"./es.json": [
		"1052",
		3,
		"lang-es"
	],
	"./index": [
		"1030",
		9
	],
	"./index.js": [
		"1030",
		9
	],
	"./pt": [
		"f57b",
		3,
		"lang-pt"
	],
	"./pt-BR": [
		"f60a",
		3
	],
	"./pt-BR.json": [
		"f60a",
		3
	],
	"./pt.json": [
		"f57b",
		3,
		"lang-pt"
	],
	"./zh-CN": [
		"9b99",
		3,
		"lang-zh-CN"
	],
	"./zh-CN.json": [
		"9b99",
		3,
		"lang-zh-CN"
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(2).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, ids[1])
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "63eb";
module.exports = webpackAsyncContext;